// whiteLabel - admin
// KundenDankeSeiteMA - admin,b1,b2
// KundenEditMA- admin,b1,b2
// MALogin- admin,b1,b2
// CustomerDankeSeite- admin,b1,b2
// KundenOrderDetailsMA- admin,b1,b2
// KundenaddressEditMA- admin,b1,b2
// KundenAddresseMA- admin,b1,b2


/**
* checkRageRightByProps()
*
*@param props.rightStorage.currentRight :[]string (RAGE_RIGHT enum) usersrage right read from right storage
*@param props.requiredRageRight :[]string (RAGE_RIGHT enum) required rage right for rendered Page (renderFunc)
*
*@return : boolean: true if a elem of props.rightStorage.currentRight matches one elem of props.requiredRageRight returns false if not or attributes are missing
*/
export function checkRageRightByProps(props) {

  //console.info("checkRageRightByProps props:", props);
  //console.info("checkRageRightByProps props.rightStorage:", props.rightStorage);
  //console.info("checkRageRightByProps props.requiredRageRight:", props.requiredRageRight);    
  //console.info("checkRageRightByProps props.rightStorage.currentRight:", props.rightStorage ? props.rightStorage.currentRight : "undefined");

  if (
    !props ||
    !props.rightStorage ||
    !Array.isArray(props.rightStorage.currentRight) ||
    !Array.isArray(props.requiredRageRight)
  ) return false;
  return checkRageRight(props.rightStorage.currentRight, props.requiredRageRight);
}

/**
* checkRageRight()
*
*@param currentRight :[]string (RAGE_RIGHT enum) usersrage right read from right storage
*@param requiredRageRight :[]string (RAGE_RIGHT enum) required rage right for rendered Page (renderFunc)
*
*@return : boolean: true if a elem of currentRight matches one elem of requiredRageRight returns false if not
*/
export function checkRageRight(currentRight = [], requiredRageRight = []) {
  for (let rageRight of currentRight) {
    //as soon as its true return true
    if (requiredRageRight.includes(rageRight)) return true;
  }
  //if no match return false
  return false;
}

/**
* isAuthenticated()
*
*@param props expected storage properties
*
*@return true if current users rage right matches one of required Rage Rights
*/
export function isAuthenticated(props) {
  if (props.configStorage && props.configStorage.isMaShop()) {
    return checkRageRightByProps(props);
  } else {
    return props.authenticationStorage && props.authenticationStorage.isSignedIn;
  }
};
